import { Link } from "react-router-dom";
import Logo from "@/components/brand/Logo";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-ds-cream">
      <aside className="hidden lg:flex relative flex-col justify-between bg-ds-creamalt p-12 overflow-hidden border-r border-ds-plum/10">
        <div className="contour absolute inset-0" aria-hidden="true" />
        <div className="relative"><Logo /></div>
        <div className="relative space-y-6 max-w-md">
          <p className="font-display text-4xl font-semibold leading-tight text-ds-plumdeep">"Not every path is visible from where you stand. A good map helps."</p>
          <svg className="w-40 h-3 text-ds-amber" viewBox="0 0 160 12" fill="none" aria-hidden="true"><path d="M3 8 C40 3 100 3 157 6" stroke="currentColor" strokeWidth="3" strokeLinecap="round" /></svg>
          <p className="text-[15px] text-ds-inksoft leading-relaxed">Career discovery for Classes 7 to 12, with a report your family can read together.</p>
        </div>
        <div className="relative flex gap-6 text-sm text-ds-inksoft">
          <Link to="/privacy" className="hover:text-ds-plum">Privacy</Link>
          <Link to="/terms" className="hover:text-ds-plum">Terms</Link>
          <Link to="/contact" className="hover:text-ds-plum">Contact</Link>
        </div>
      </aside>
      <main className="flex flex-col justify-center px-5 sm:px-12 py-10">
        <div className="lg:hidden mb-10"><Logo /></div>
        <div className="w-full max-w-md mx-auto rise">
          <h1 className="font-display text-3xl sm:text-4xl font-semibold leading-tight text-ds-plumdeep" data-testid="auth-title">{title}</h1>
          {subtitle && <p className="mt-2 text-[16px] text-ds-inksoft">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-8 text-[15px] text-ds-inksoft">{footer}</div>}
        </div>
      </main>
    </div>
  );
}
